import { Link } from 'react-router-dom';
import { Nav, Container, Navbar as BsNavbar } from 'react-bootstrap';

import UserDropdown from './UserDropdown';
import { useAuth } from 'src/AuthContext';
import { ACCOUNT_TYPE } from 'src/constants/authConstants';

export default function Navbar() {
  const { user } = useAuth();
  const showUserManagement = [
    'shmuelt',
    'yitzn',
    'davidp',
    'saras',
    'jeff',
    'jennifert',
    'joe',
    'asommer',
    'ajay',
  ].some((prefix) => user.email.startsWith(prefix));
  const logoUrl = () => {
    if (user?.accountType === ACCOUNT_TYPE.ALCOVE) {
      return '/assets/logo/alcove-icon.png';
    }
    if (user?.accountName === 'PRO Department') {
      return '/assets/logo/modular-logo.svg';
    }
    return 'https://modular-images-public.s3.us-east-2.amazonaws.com/logo-wide.svg';
  };

  const showAutoRender = user.accountType === ACCOUNT_TYPE.MULTIFAMILY;

  return (
    <BsNavbar
      style={{
        background: 'white',
        position: 'sticky',
        top: 0.25,
        zIndex: 1000,
        borderBottom: '1px solid #9CA3AF33',
      }}
      expand='sm'
    >
      <Container className='d-flex'>
        <BsNavbar.Brand>
          <Link to='/' id='logo-full' style={{ textDecoration: 'none' }}>
            <img src={logoUrl()} alt='Company Logo' style={{ height: '54px' }} />
          </Link>
        </BsNavbar.Brand>

        <BsNavbar.Toggle aria-controls='basic-navbar-nav' />
        <BsNavbar.Collapse id='basic-navbar-nav' className='justify-content-end'>
          <Nav>
            {showAutoRender && (
              <Nav.Link as={Link} to='/auto-render' style={{ marginRight: '20px' }}>
                Auto Render
              </Nav.Link>
            )}
            {showAutoRender && (
              <Nav.Link as={Link} to='/tax' style={{ marginRight: '20px' }}>
                Tax Dashboard
              </Nav.Link>
            )}
            {showUserManagement && (
              <Nav.Link as={Link} to='/admin/users' style={{ marginRight: '20px' }}>
                User Management
              </Nav.Link>
            )}
            <UserDropdown />
          </Nav>
        </BsNavbar.Collapse>
      </Container>
    </BsNavbar>
  );
}
